import React from 'react'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import TaskLogSF from './TaskLogSF'

const TaskLogListUI = ({context, messageList, taskLogList, project, task, projectUserMap,
    onTaskLogListUpdate, onForceTaskListRefresh, onForceTaskLogListRefresh
  }) =>
  <div className='c_tsk_msgs g_h_100'>
    {
      !taskLogList &&
      <SpinnerComponentUI />
    }
    {
      taskLogList && taskLogList.map((taskLog, i) =>
        <TaskLogSF
          key={i}
          context={context}
          messageList={messageList}
          projectUserMap={projectUserMap}
          taskLogList={taskLogList}
          project={project}
          taskLog={taskLog}
          task={task}
          onTaskLogListUpdate={onTaskLogListUpdate}
          onForceTaskListRefresh={onForceTaskListRefresh}
          onForceTaskLogListRefresh={onForceTaskLogListRefresh}
        />
      )
    }
  </div>

export default TaskLogListUI
